import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import * as Sentry from '@sentry/react';

/**
 * Expose Sentry Client instance to make mocking possible in tests.
 */
export const sentry = Sentry.init({
  dsn: 'https://1bd5ee288a635ef3f32bd67363aa8209@o321856.ingest.us.sentry.io/4506896864706560',
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.browserProfilingIntegration(),
  ],
  // disable console instrumenting for development and test builds
  defaultIntegrations: process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development' ? false : undefined,
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/\w+(\.\w)?\.alloyads.ai\/api/],
  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 1.0,
  // Session Replay
  environment: process.env['REACT_APP_STAGE'] || 'local',

  beforeSend(event) {
    if (process.env.NODE_ENV === 'development') {
      // Filter duplicate errors
      if (event.extra?.componentStack) {
        return null;
      }
    }
    return event;
  },
})!;
